/**
 * Platform Groups Constants
 * Platform groups for ChannelMenu component
 */

import type { ChannelType } from "@interfaces/chat.interface";
import FacebookIcon from "@assets/facebook-icon.svg";
import ZaloIcon from "@assets/zalo-icon.svg";
import ShopeeIcon from "@assets/shopee-icon.svg";
import TiktokIcon from "@assets/tiktok.svg";
import { SettingOutlined } from "@ant-design/icons";

export interface SubMenuItem {
  id: string;
  label: string;
  path: string;
  onClick?: () => void;
}

export interface PlatformGroup {
  id: string;
  label: string;
  icon: React.ReactNode;
  channelTypes: ChannelType[];
  submenu?: SubMenuItem[];
}

export const PLATFORM_GROUPS: PlatformGroup[] = [
  {
    id: "facebook",
    label: "Facebook",
    icon: <img src={FacebookIcon} alt="Facebook" />,
    channelTypes: ["facebook"],
  },
  {
    id: "zalo",
    label: "Zalo",
    icon: <img src={ZaloIcon} alt="Zalo" />,
    channelTypes: ["zalo"],
  },
  {
    id: "shopee",
    label: "Shopee",
    icon: <img src={ShopeeIcon} alt="Shopee" />,
    channelTypes: ["shopee"],
  },
  {
    id: "tiktok",
    label: "Tiktok",
    icon: <img src={TiktokIcon} alt="Tiktok" />,
    channelTypes: ["tiktok"],
  },
  {
    id: "setting",
    label: "Cài đặt",
    icon: <SettingOutlined />,
    channelTypes: [],
    submenu: [
      {
        id: "facebook-templates",
        label: "Mẫu template Facebook",
        path: "/settings/facebook-templates",
      },
    
      // {
      //   id: "account",
      //   label: "Tài khoản",
      //   path: "/settings/account",  
      // },
    ],
  },
];
